<template>
  <div class="inner-box">
    <div class="content-name">
      <h2 class="dp-ib" style="height: 33px">{{title}}</h2>
      <div class="btn-wrap btn-type1 clearfix" style="margin-bottom: 0">
        <button v-if="(this.$store.state.loginInfo.loginId === this.thisApprUser || this.deleYn ==='Y') && (docStatus == 'REQ' || docStatus == 'ING') " class="btn-size btn-blue" @click="openApprPopup()"><span class="btn-icon"><i
            class="fas fa-pen-alt"></i></span> 결재
        </button>
        <button v-if="this.$store.state.loginInfo.loginId == draftUserId && docStatus === 'REQ'"
                class="btn-size btn-yellow" @click="cancel(docMngNo)"><span class="btn-icon"><i class="far fa-file"></i></span> 상신취소
        </button>


        <button v-if="(this.$store.state.loginInfo.loginId === this.thisApprUser
                                     || this.$store.state.loginInfo.authorities[0].roleCd ==='ADMIN')
                                     && (this.docStatus === 'REQ' || this.docStatus === 'ING')"class="btn-size btn-blue" @click="openLinePopup()">
          <span class="btn-icon"><i class="fas fa-user-check"></i></span> 결재선 변경
        </button>
        <button v-if="(this.$store.state.loginInfo.loginId === this.thisApprUser
                                     || this.$store.state.loginInfo.authorities[0].roleCd ==='ADMIN')
                                     && (this.docStatus === 'REQ' || this.docStatus === 'ING')" class="btn-size btn-yellow" @click="openReferPopup()">
          <span class="btn-icon"><i class="fas fa-user-plus"></i></span> 참조자 변경
        </button>


        <button class="btn-size btn-gray fl_left" @click="goBack()">
                    <span class="btn-icon">
                      <i class="fas fa-arrow-circle-left"></i>
                    </span>뒤로가기
        </button>
      </div>
    </div>

    <appr-dtl v-if="isLoaded" v-model="data" :approval-line.sync="apprLine" :reference-line.sync="referLine"
              :docMngNo="docMngNo" :docType="docType" @approvalLine="changeApprovalLineEvent" @referenceLine="changeReferLineEvent" @input="$forceUpdate()"
              @apprInfo="apprInfoCheck"/>

    <b-modal :active.sync="showVendorModal1" has-modal-card @receive="getAppr">
      <appr-act-pop :docTitleNm="docTitleNm" :apprNo="apprNo" :apprSeq="apprSeq"></appr-act-pop>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import mixin from '@/mixin';
import mixinSlip from '@/mixin/slip';
import _ from 'lodash'

import ApprDtl from '@/components/ApprDtl.vue'
import ApprHeader from '@/components/ApprHeader.vue'
import ApprActPop from '@/components/ApprActPop.vue'
import ApprLineSet from "@/components/ApprLineSet";
import ApprReferSet from "@/components/ApprReferSet";

export default {
  name: 'ApprDtlQry',
  props: {
    docMngNo: {
      type: String,
      required: false
    },
    value: {
      type: Object,
      required: false
    }
  },
  mixins: [mixin, mixinSlip],
  components: {ApprHeader, ApprActPop, ApprDtl},
  data() {
    return {
      data: {},
      title: '결재 상세',
      apprHeader: {},
      apprLine: [],
      referLine: [],
      budReqNo: undefined,
      apprNo: '',
      apprSeq: '',
      docTitleNm: '',
      docTypeCd: '',
      docType: 'SHORT',
      docStatus: '',
      draftUserId: '',
      thisApprUser: '',
      deleYn: 'N',
      loaded: false,
      showVendorModal1: false,
    };
  },
  methods: {
    getAppr(docMngNo) {
      this.loaded = false

      if (docMngNo != undefined) {
        this.$http.get(`/api/appr/detail/${docMngNo}`)
            .then(response => {
              if (response.data) {
                this.apprSeq = ''
                this.thisApprUser = ''

                this.data = response.data.visitHeader;
                this.data.visitDetails = response.data.visitDetails;

                //핸드폰 번호 유형으로 변환
                let regExp =/(01[016789])([0-9]{1}[0-9]{2,3})([0-9]{4})$/
                let myArray
                for(let i=0; i<this.data.visitDetails.length; i++){
                  myArray = regExp.exec(this.data.visitDetails[i].visitorMobile)
                  this.data.visitDetails[i].visitorMobile = myArray[1] + '-' + myArray[2] + '-' + myArray[3]
                }
                myArray = regExp.exec(this.data.visitorFirstMobile)
                this.data.visitorFirstMobile = myArray[1] + '-' + myArray[2] + '-' + myArray[3]


                this.apprHeader = response.data.apprHeader[0];
                this.apprLine = response.data.apprDetails;

                this.docTypeCd = response.data.apprHeader[0].docTypeCd;
                this.docStatus = response.data.apprHeader[0].docStatCd;
                this.draftUserId = response.data.apprHeader[0].draftUserId;
                this.docTitleNm = response.data.apprHeader[0].docTitleNm;
                this.apprNo = response.data.apprHeader[0].apprNo;

                _.forEach(this.apprLine, v => {
                  if (v.apprFgCd ==='X') {
                    this.apprSeq = v.apprSeq
                    this.thisApprUser = v.aprverId
                    return false
                  }
                })

                this.loaded = true

                this.$emit('approvalLine', this.apprLine)
              }
            })
            .catch(({message}) => {
              console.error(message);
              this.$swal({
                type: 'error',
                text: '잘못된 접근이거나 권한이 없습니다.'
              }).then(()=> {
                this.$router.push({path: `/backOffice`});
              })
            })
      }
    },
    deleCheck() {
      this.$http.get(`/api/appr/delegatingCheck`, {
        params: {
          adlgId: this.thisApprUser,
          actId: this.$store.state.loginInfo.loginId
        }
      })
          .then(response => {
            this.deleYn = response.data;
          });
    },
    cancel(docMngNo) {
      this.$swal({
        type: 'info',
        text: `상신을 취소합니다. 계속 하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          if (docMngNo != undefined) {
            this.$http.get(`/api/appr/detail/cancel/${docMngNo}`)
                .then(response => {
                  if (response.data) {
                    this.$router.push({path: `/backOffice/apprReqLst`});
                  }
                })
                .catch(({message}) => {
                  console.error(message);
                });
          }
        }
      })
    },
    openLinePopup() {
      let vm = this
      this.$modal.open({
        component: ApprLineSet,
        props: {
          lineList: this.apprLine
        },
        parent: this,
        events: {
          close(data) {
            // Close event handler
            vm.apprLine = data.lineList || []
          }
        }
      })
    },
    openReferPopup() {
      let vm = this
      this.$modal.open({
        component: ApprReferSet,
        props: {
          lineList: this.referLine,
          apprNo: this.docMngNo
        },
        parent: this,
        events: {
          close(data) {
            // Close event handler
            vm.referLine = data.lineList || []
          }
        }
      })
    },

    openApprPopup() {
      let vm = this
      this.$modal.open({
        component: ApprActPop,
        props: {
          docTitleNm: this.docTitleNm,
          apprNo: this.apprNo,
          apprSeq: this.apprSeq
        },
        parent: this,
        events: {
          close(data) {
            // Close event handler
            vm.getAppr(data)
          }
        }
      })
    },
    changeApprovalLineEvent(data) {
      this.apprLine = data
    },
    changeReferLineEvent(data) {
      this.referLine = data
    },
    apprInfoCheck(data) {
      this.apprInfo = data
    },
    popVendor1(clear) {
      this.showVendorModal1 = true;
    },
    receiveVendor1(obj) {
      this.docTitleNm = obj.docTitleNm;
    },
    goBack(){
      this.$router.go(-1);
    }
  },
  created() {
    this.getAppr(this.docMngNo);
  },
  computed: {
    isLoaded() {
      return this.loaded
    },
  },
  watch: {
    'loaded'() {
      this.deleCheck()
    },
  }
};
</script>

<style>
</style>

